var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('textarea',{ref:"textarea",staticClass:"growing-textarea",domProps:{"value":_vm.value},on:{"input":_vm.resize}})}
var staticRenderFns = []

export { render, staticRenderFns }